import React from "react";
import OrderSelector from "./OrderSelector";

/**
 * LocationSelector Component
 * Wrapper for OrderSelector configured for locations
 */
export default function LocationSelector({
  brandColor,
  title,
  searchPlaceholder,
}) {
  return (
    <OrderSelector
      type="location"
      brandColor={brandColor}
      title={title}
      searchPlaceholder={searchPlaceholder}
      itemIcon="location"
    />
  );
}
